// @ts-nocheck
import * as Types from '../../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type PlanPackageRecentActivityQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type PlanPackageRecentActivityQuery = { __typename?: 'Query', planPackage: { __typename?: 'PlanPackage', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, programDataModifiedBy: Array<{ __typename?: 'ReadyPlanOptionProgramDataModification', id: string }> }>, aggregateVersions: Array<{ __typename?: 'ReadyPlanAggregateVersion', id: string }> } };


export const PlanPackageRecentActivityDocument = gql`
    query PlanPackageRecentActivity($id: ID!) {
  planPackage(id: $id) {
    id
    options {
      id
      programDataModifiedBy {
        id
      }
    }
    aggregateVersions {
      id
    }
  }
}
    `;

/**
 * __usePlanPackageRecentActivityQuery__
 *
 * To run a query within a React component, call `usePlanPackageRecentActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanPackageRecentActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanPackageRecentActivityQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePlanPackageRecentActivityQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PlanPackageRecentActivityQuery, PlanPackageRecentActivityQueryVariables> & ({ variables: PlanPackageRecentActivityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PlanPackageRecentActivityQuery, PlanPackageRecentActivityQueryVariables>(PlanPackageRecentActivityDocument, options);
      }
export function usePlanPackageRecentActivityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PlanPackageRecentActivityQuery, PlanPackageRecentActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PlanPackageRecentActivityQuery, PlanPackageRecentActivityQueryVariables>(PlanPackageRecentActivityDocument, options);
        }
// @ts-ignore
export function usePlanPackageRecentActivitySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PlanPackageRecentActivityQuery, PlanPackageRecentActivityQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PlanPackageRecentActivityQuery, PlanPackageRecentActivityQueryVariables>;
export function usePlanPackageRecentActivitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlanPackageRecentActivityQuery, PlanPackageRecentActivityQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PlanPackageRecentActivityQuery | undefined, PlanPackageRecentActivityQueryVariables>;
export function usePlanPackageRecentActivitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlanPackageRecentActivityQuery, PlanPackageRecentActivityQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PlanPackageRecentActivityQuery, PlanPackageRecentActivityQueryVariables>(PlanPackageRecentActivityDocument, options);
        }
export type PlanPackageRecentActivityQueryHookResult = ReturnType<typeof usePlanPackageRecentActivityQuery>;
export type PlanPackageRecentActivityLazyQueryHookResult = ReturnType<typeof usePlanPackageRecentActivityLazyQuery>;
export type PlanPackageRecentActivitySuspenseQueryHookResult = ReturnType<typeof usePlanPackageRecentActivitySuspenseQuery>;
export type PlanPackageRecentActivityQueryResult = Apollo.QueryResult<PlanPackageRecentActivityQuery, PlanPackageRecentActivityQueryVariables>;